var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('ChartLegend',{attrs:{"items":_vm.legend}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center"},[_c('div',{staticClass:"chart-container",attrs:{"id":"traffic-chart","data-test-id":"traffic-chart"}})])
}]

export { render, staticRenderFns }